import { useAuthStore } from "../stores/authStore";

export async function apiClient(endpoint, options = {}) {
  const authStore = useAuthStore();

  if (!authStore.apiBase || !authStore.apiKey) {
    console.debug("[apiClient] No backend configured — skipping:", endpoint);
    return null;
  }

  const { responseType, ...fetchOptions } = options;

  const headers = {
    "X-API-Key": authStore.apiKey,
    ...fetchOptions.headers,
  };

  if (!(fetchOptions.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(`${authStore.apiBase}${endpoint}`, {
    ...fetchOptions,
    headers,
  });

  if (responseType === "blob") {
    if (!response.ok) throw new Error(`Failed to download: ${response.status}`);
    return response.blob();
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const message =
      typeof errorData.detail === "string"
        ? errorData.detail
        : errorData.detail?.message ?? `Request failed: ${response.status}`;
    throw new Error(message);
  }

  if (response.status === 204 || response.headers.get("content-length") === "0") {
    return null;
  }

  return response.json();
}

export async function getAuthenticatedImageUrl(endpoint, { silent = false } = {}) {
  try {
    const blob = await apiClient(endpoint, { responseType: "blob" });
    return URL.createObjectURL(blob);
  } catch (err) {
    if (!silent) console.error("[apiClient] Failed to load image:", endpoint, err);
    return null;
  }
}